/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DatahubLoader = {
    id: string;
    parameters: Record<string, any> | null;
    result?: Record<string, any> | null;
    state: DatahubLoader.state;
    userId?: number | null;
    type: DatahubLoader.type;
    createdAt: string;
    updatedAt: string;
};

export namespace DatahubLoader {

    export enum state {
        ENQUEUED = 'ENQUEUED',
        IN_PROGRESS = 'IN_PROGRESS',
        FINISHED = 'FINISHED',
        ERROR = 'ERROR',
        PAUSED = 'PAUSED',
        CANCELLED = 'CANCELLED',
    }

    export enum type {
        SURVEY = 'survey',
        BC_LEVEL_MAPPING = 'bcLevelMapping',
        MODULE_JOB = 'moduleJob',
        SURVEY_JOB_ROLLUP = 'surveyJobRollup',
        SURVEY_JOB_DEFINITION_MAPPING = 'surveyJobDefinitionMapping',
    }


}

